import { colors } from "../../Styles";

export function Condition({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <polygon points="71.65 156.38 57.02 111.35 9.68 111.35 47.98 83.53 33.35 38.51 71.65 66.33 109.95 38.51 95.32 83.53 133.62 111.35 86.28 111.35 71.65 156.38"/>
      <polygon points="246.08 172.99 208.63 144.03 169.52 170.7 185.49 126.13 148.04 97.17 195.36 98.59 211.33 54.03 224.6 99.46 271.92 100.88 232.81 127.55 246.08 172.99"/>
      <polygon points="159.05 268.76 121.6 239.81 82.49 266.47 98.46 221.91 61.01 192.95 108.32 194.37 124.29 149.8 137.57 195.24 184.88 196.66 145.77 223.32 159.05 268.76"/>
    </svg>
  );
}
